import { Document, Font, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import React from "react";
import PropTypes from "prop-types";
import PdfTotalPage from "./PdfTotal/PdfTotalExport";

Font.register({
  family: "Vazir",
  src: "/fonts/Vazirmatn-FD-Medium.ttf",
});

const PdfPage = ({ data }) => {
  const styles = StyleSheet.create({
    page: {
      padding: 30,
      fontSize: 10,
      fontFamily: "Vazir",
    },
    section2: {
      marginBottom: 10,
    },
    section: {
      margin: 10,
      padding: 10,
      border: "1pt solid black",
      borderRadius: 5,
    },
    row: {
      flexDirection: "row",
      justifyContent: "space-between",
      borderBottom: "1pt solid black",
      paddingVertical: 5,
    },
    textRight: {
      textAlign: "right",
      direction: "ltr",
    },
    textLeft: {
      textAlign: "left",
      direction: "rtl",
    },
    footer: {
      textAlign: "center",
      borderTop: "1pt solid black",
      paddingTop: 10,
      marginTop: 10,
    },
    header: {
      textAlign: "right",
      direction: "rtl",
      marginBottom: 10,
    },
    title: {
      textAlign: "center",
      fontSize: 14,
      marginBottom: 10,
      fontWeight: "bold",
    },
  });

  const chunkArray = (array, size) => {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  };

  const pages = chunkArray(data, 2);

  return (
    <Document>
      {pages.map((pageItems, pageIndex) => (
        <Page size="A4" style={styles.page} key={pageIndex}>
          {pageItems.map((item, ind) => (
            <View style={styles.section2} key={ind}>
              <Text style={styles.title}>{process.env.REACT_APP_PDF_TITLE}</Text>

              <View style={styles.header}>
                <Text>نوع گزارش: تفصیلی</Text>
                <Text></Text>
              </View>

              <View style={styles.section}>
                <View style={styles.row}>
                  <Text>شماره حواله: {item.cargo_code}</Text>
                  <Text>نوع عملیات : {item.type}</Text>
                  <Text style={styles.textLeft}>ساعت: {item.date?.split(" ")[0]}</Text>
                  <Text style={styles.textLeft}>تاریخ: {item.date?.split(" ")[1]}</Text>
                </View>
                <View style={styles.row}>
                  <Text style={styles.textLeft}>پروژه: {item.project.title}</Text>
                  <Text style={styles.textLeft}>محل استقرار: {item.location.name}</Text>
                  <Text style={styles.textLeft}>نوع دستگاه: {item.machine.type}</Text>
                  <Text style={styles.textLeft}>نام دستگاه: {item.machine.name}</Text>
                </View>
                <View style={styles.row}>
                  <Text style={styles.textLeft}>شیفت: {item.shift?.name}</Text>
                  <Text style={styles.textLeft}>نقص فنی: {item.defect?.name}</Text>
                  <Text style={styles.textLeft}>تاخیر: {item.delays?.name}</Text>
                  <Text style={styles.textLeft}>تراز: {item.balance}</Text>
                </View>
                <View style={styles.row}>
                  <Text style={styles.textLeft}>مدت زمان بارگیری: {item.duration}</Text>
                  <Text style={styles.textLeft}>اپراتور: {item.operator.name}</Text>
                  <Text style={styles.textLeft}>تجهیز بارگیری: {item.equipment.name}</Text>
                </View>
                <View style={styles.row}>
                  <Text style={styles.textRight}>هزینه کل عملیات: {item.sum_amount_with}</Text>

                  <Text style={styles.textLeft}>کرایه: {item.amount_with}</Text>

                  <Text style={styles.textLeft}>پیمانکار: {item.peymankar.name}</Text>
                </View>
                {item.jens &&
                  item.jens.length > 0 &&
                  item.jens.map((jensItem, jensIndex) => (
                    <View key={jensIndex} style={styles.row}>
                      <Text style={styles.textLeft}>واحد: {jensItem["weight"]["title"]}</Text>

                      <Text style={styles.textLeft}>وزن: {jensItem["weight_unit"]}</Text>

                      <Text style={styles.textLeft}>شماره کالا: {jensItem["jens_number"]}</Text>

                      <Text style={styles.textLeft}>تعداد: {jensItem["jens_unit"]}</Text>

                      <Text style={styles.textLeft}>کدکالا: {jensItem["jens_code"]["title"]}</Text>

                      <Text style={styles.textLeft}>کالا: {jensItem["title"]}</Text>
                    </View>
                  ))}
                <View style={styles.row}>
                  <Text style={styles.textRight}>
                    توضیحات: {"\n"}
                    {item.desc}
                  </Text>

                  <Text style={styles.textLeft}>مقصد: {item.destination?.title}</Text>

                  <Text style={styles.textLeft}>مبدا: {item.origin?.title}</Text>
                </View>
              </View>

              <Text style={styles.footer}>
                (نرم افزار مدیریت بارگیری بارگو) 91096293-021 www.bargosoftware.com
              </Text>
            </View>
          ))}
        </Page>
      ))}
    </Document>
  );
};

export default PdfPage;

PdfPage.propTypes = {
  data: PropTypes.array,
};
